/**
 * DescriptionTitle component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled description title.
 */
const DescriptionTitle = styled.div<{ limitWidth?: boolean }>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${(props) =>
    props.limitWidth
      ? `${42 * Screen.widthRatio}px`
      : `${56 * Screen.widthRatio}px`};
  height: ${(props) =>
    props.limitWidth
      ? `${50 * Screen.widthRatio}px`
      : `${64 * Screen.widthRatio}px`};
  margin-bottom: ${24 * Screen.widthRatio}px;
  overflow: hidden;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.8);
  width: ${(props) =>
    props.limitWidth
      ? `${730 * Screen.widthRatio}px`
      : `${986 * Screen.widthRatio}px`};
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export default DescriptionTitle;
